import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdfAnnotator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#1BCFC4" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m16.026 10.734-2.76-2.76M5.333 18.667l2.335-.26c.285-.032.428-.047.561-.09q.177-.059.335-.161c.117-.078.218-.179.421-.382l9.11-9.11a1.951 1.951 0 1 0-2.76-2.76l-9.11 9.11c-.202.204-.304.305-.38.422a1.4 1.4 0 0 0-.162.335c-.043.133-.059.276-.09.56z"
    />
  </svg>
);
export default SvgPdfAnnotator;
